import CheckboxRadioButtons from './components/bs4-checkbox-radio.jsx';

export default CheckboxRadioButtons;
